module.exports = __webpack_public_path__ + "img/2023_FR.6d2f468f.png";